














































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class Textarea extends Vue {
  @Prop({ default: "" }) readonly placeholder!: string;
  @Prop({ default: "text" }) readonly name!: string;
  @Prop({ default: "label" }) readonly label!: string | boolean;
  @Prop({ default: false }) readonly isTrim!: false;
  @Prop({ default: false }) readonly isRemoveWhiteSpace!: false;
  @Prop({}) readonly tooltipPosition!: string;
  @Prop({ default: "", validator: (val: string) => ["blue", ""].includes(val) }) readonly textColor!: string;
  @Prop({}) readonly tooltip!: string | Array<string>;
  @Prop({ default: false }) readonly inputError!: boolean;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: "" }) readonly maxlength!: string;
  @Prop({ default: 0 }) readonly maxlines!: number;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: "" }) readonly value!: string | boolean;
  @Prop({ default: "100%" }) readonly height!: string;

  private inputFocus: any = false;
  private inputValue: any = "";
  private styleInput: any = "";
  created() {
    this.inputValue = this.value;
  }
  @Watch("value")
  valueChange(newValue: any, oldValue: any) {
    this.inputValue = newValue;
  }

  @Watch("inputValue")
  inputValueChange() {
    this.$emit("update:value", this.inputValue);
  }

  @Watch("inputError", { immediate: true })
  inputErrorChange() {
    this.styleInput = this.inputError ? "error" : "";
  }

  public CheckValidateMaxlengthAndMaxlines() {
    if (this.LabelMaxlength() < 0 || this.LabelMaxlines() < 0) {
      this.$emit("update:inputError", true);
      this.styleInput = "error";
      return true;
    } else {
      this.$emit("update:inputError", false);
      this.styleInput = this.inputError ? "error" : "";
      return false;
    }
  }

  public LabelMaxlength(): any {
    if (this.maxlength && this.inputValue) {
      const maxlength = parseInt(this.maxlength);
      const length = (maxlength - this.inputValue.toString().length).FormatMoney(0);
      return length;
    } else if (this.maxlength) {
      return parseInt(this.maxlength).FormatMoney(0);
    }
  }

  public LabelMaxlines(): any {
    if (this.maxlines && this.inputValue) {
      const lines = this.inputValue.split("\n").length;
      const remainingLines = this.maxlines - lines;
      return remainingLines;
    } else if (this.maxlines) {
      return this.maxlines;
    }
  }

  public onblur() {
    if (this.required) {
      this.$emit("update:inputError", true);
      this.styleInput = "error";
    } else {
      this.$emit("update:inputError", false);
      this.styleInput = this.inputError ? "error" : "";
    }
  }

  public TrimText(input: any) {
    if (input && this.isTrim && this.isRemoveWhiteSpace) {
      return input
        .trim()
        .split(" ")
        .join("")
        .replace(/[\r\n]+/gm, "");
    } else if (input && this.isTrim) {
      return input.trim();
    } else {
      return input;
    }
  }
}
